import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "rc-dropdown/assets/index.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import "react-responsive-modal/styles.css";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import store from "./State/Store";
import { Provider } from "react-redux";

// responsive layout grid styling

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

// Create a new instance of QueryClient
const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        {/* <PersistGate loading={null} persistor={persistStore(store)}> */}
        <BrowserRouter>
          <App />
        </BrowserRouter>
        {/* </PersistGate> */}
      </Provider>
    </QueryClientProvider>
  </React.StrictMode>,
);
